<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="stockAction === 'received' ? 800 : 568" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Update stock
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.py-3
      div.d-flex.align-center(v-if="showProductName")
        .text-lg.font-semibold.neutral700--text {{ product.name }}
        v-spacer
        .text-sm.font-semibold.neutral500--text.pl-3 UOM: {{ displayUom }}
      div.d-flex.align-center(:class="showProductName ? 'mt-1' : 'mt-3'")
        .text-md.font-semibold.neutral700--text Stock on hand ({{ stockCount }})
        v-spacer
        div.text-sm.neutral700--text(v-html="getCurrentStock()")
      v-form.mt-3(ref="form")
        v-row.mt-4(no-gutters)
          v-col(cols="6")
            y-select(v-model="stockAction" placeholder="Select stock action" :items="actions" item-text="text" item-value="value" outlined height="48" menu-height="250" :rules="rules.not_empty_select" hide-details="auto")
          v-col(cols="4" offset="2")
            v-text-field.text-sm.round-xl(v-model="stockChange" placeholder="Enter value" outlined dense height="48" type="number" :prefix="getPrefix(stockAction)" :disabled="!stockAction" :rules="rules.stock_quantity" hide-details="auto" @input="checkAction")
        template(v-if="stockAction === 'received'")
          //- template(v-if="!addInvoice")
            div.text-sm.font-semibold.neutral500--text.mt-6 Invoice
            v-row.my-0(align="center")
              v-col(cols="8")
                //- medication-sold-by-dropdown(v-model="seller" show-person-in-charge)
                invoice-dropdown(v-model="invoice" show-person-in-charge)
              v-col(cols="1")
                div.text-sm.font-semibold.neutral700--text.text-center OR
              v-col
                y-button(label="Add new invoice" underline color="neutral700" size="md" button-class="px-3" @click="changeInvoiceSelection(true)")
          //- template(v-else)
            div.d-flex.align-center.mt-4
              div.text-sm.font-semibold.neutral500--text Invoice
              v-spacer
              y-button(label="Select from existing invoice" underline color="neutral700" size="sm" button-class="px-3" @click="changeInvoiceSelection(false)")
            v-row.my-0
              v-col
                div.text-sm.font-semibold.neutral500--text Invoice number
                v-text-field.text-sm.mt-2.round-xl(v-model="stockInvoiceNo" placeholder="Invoice number" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
              v-col
                div.text-sm.font-semibold.neutral500--text Invoice date
                y-dialog(v-model="showInvoicePicker" width='320px' persistent)
                  template(v-slot:activator='{ on }')
                    v-text-field.text-sm.mt-2.round-xl.date-field(v-model="invoiceDateField" placeholder="Invoice date" outlined dense height="48" readonly :rules="rules.not_empty" hide-details="auto" v-on="on" clearable)
                      template(v-slot:append)
                        eva-icon(name="calendar-outline" fill="#848484")
                  v-card
                    v-card-text.px-2.pt-2.pb-0
                      yc-date-picker(:parentDate.sync="selectedInvoiceDate" color="info")
                    v-card-actions.px-4.pb-4
                      v-row(no-gutters)
                        v-col.pr-2
                          v-btn.button-sm(color="basic700" block dark outlined depressed @click="showInvoicePicker = false") {{ $t('cancel') }}
                        v-col.pl-2
                          v-btn.button-sm(color="info500" block depressed dark @click="pickDate('invoiceDateField', 'showInvoicePicker', selectedInvoiceDate)") {{ $t('select') }}
              v-col
                div.text-sm.font-semibold.neutral500--text Sold by
                medication-sold-by-dropdown.mt-2(v-model="seller" show-add-seller :error="showSellerError" @closed="showSellerError = false")
          v-row.my-0
            v-col
              div.text-sm.font-semibold.neutral500--text Stock cost
              v-text-field.text-sm.mt-2.round-xl(v-model="stockCost" placeholder="100" outlined dense height="48" type="number" :prefix="$currency.symbol" :rules="rules.has_price" hide-details="auto" @input="updateCost")
            v-col
              div.text-sm.font-semibold.neutral500--text Cost per item
              v-text-field.text-sm.mt-2.round-xl(v-model="costPerItem" placeholder="0.00" background-color="neutral300" outlined dense height="48" type="number" :prefix="$currency.symbol" disabled hide-details="auto")
          div.d-flex.align-center.mb-2
            v-icon.mr-1(size="20") mdi-information-outline
            div.text-xs.neutral700--text Fill up stock cost to get an accurate cost per item.
          v-row.my-0
            v-col
              div.text-sm.font-semibold.neutral500--text Batch number
              v-text-field.text-sm.mt-2.round-xl(v-model="stockBatchNo" placeholder="Batch number" outlined dense height="48" hide-details="auto")
            v-col
              div.text-sm.font-semibold.neutral500--text Expiry date
              y-dialog(v-model="showExpiredPicker" width='320px' persistent)
                template(v-slot:activator='{ on }')
                  v-text-field.text-sm.mt-2.round-xl.date-field(v-model="expiryDateField" placeholder="Expiry date" outlined dense height="48" readonly hide-details="auto" v-on="on" clearable)
                    template(v-slot:append)
                      eva-icon(name="calendar-outline" fill="#848484")
                v-card
                  v-card-text.px-2.pt-2.pb-0
                    yc-date-picker(:parentDate.sync="selectedExpiryDate" color="info")
                  v-card-actions.px-4.pb-4
                    v-row(no-gutters)
                      v-col.pr-2
                        v-btn.button-sm(color="basic700" block dark outlined depressed @click="showExpiredPicker = false") {{ $t('cancel') }}
                      v-col.pl-2
                        v-btn.button-sm(color="info500" block depressed dark @click="pickDate('expiryDateField', 'showExpiredPicker', selectedExpiryDate)") {{ $t('select') }}
        v-row.my-0
          v-col
            div.text-sm.font-semibold.neutral500--text Remarks
            v-textarea.text-sm.mt-2.round-xl(v-model="remarks" placeholder="Write your remarks here" outlined rows="4" hide-details="auto")

    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Save" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MedicationSoldByDropdown from '@/components/clinic/inventory/MedicationSoldByDropdown.vue'
import InvoiceDropdown from '@/components/clinic/inventory/InvoiceDropdown.vue'

export default {
  components: { MedicationSoldByDropdown, InvoiceDropdown },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stockCount: {
      default: null
    },
    product: {
      default: null
    },
    showProductName: {
      default: false
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      showInvoicePicker: false,
      showExpiredPicker: false,
      showSellerError: false,
      addInvoice: false,
      stockAction: null,
      stockChange: null,
      stockCost: null,
      stockBatchNo: null,
      stockInvoiceNo: null,
      costPerItem: null,
      selectedInvoiceDate: null,
      selectedExpiryDate: null,
      invoiceDateField: null,
      expiryDateField: null,
      remarks: null,
      seller: {},
      invoice: {},
      actions: [
        { text: 'Stock received', value: 'received' },
        { text: 'Inventory re-count', value: 're-count' },
        { text: 'Damage', value: 'damage' },
        { text: 'Theft', value: 'theft' },
        { text: 'Loss', value: 'loss' },
        { text: 'Expired', value: 'expired' },
        { text: 'Stock return', value: 'return' },
        { text: 'Clinic use', value: 'use' },
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
        stock_quantity: [
          v => (v != null && v.toString().trim().length) || 'This field is required',
          v => (((this.stockAction === 'received' || this.stockAction === 're-count') && v >= 0) || ((this.stockAction === 'return' || this.stockAction === 'damage' || this.stockAction === 'theft' || this.stockAction === 'loss' || this.stockAction === 'use' || this.stockAction === 'expired') && v <= this.stockCount)) || 'Invalid  value',
          // v => ((this.stockAction === 'damage' || this.stockAction === 'theft' || this.stockAction === 'loss') && v <= this.stockCount) || 'Invalid  value',
        ]
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    displayUom () {
      if (!this.product) return '-'
      if (this.product.uom_conversion_enabled && this.product.uom_conversions?.length > 0) {
        return this.product.uom_conversions[this.product.uom_conversions.length - 1].convert_to
      }
      return this.product.uom || '-'
    },
    stock () {
      let action = this.stockAction
      let change = null
      if (action === 're-count') {
        change = Number(this.stockChange) - Number(this.stockCount)
      } else if (action === 'received') {
        change = Number(this.stockChange)
      } else {
        change = Number('-' + this.stockChange)
      }
      return { action, change }
    }
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      // if (this.addInvoice && Object.keys(this.seller).length == 0) {
      //   this.showSellerError = true
      //   return
      // }
      this.isLoading = true
      let data = {
        ...this.stock,
      }
      if (this.stockAction === 'received') {
        data.cost = Math.round(Number(this.stockCost) * Number(this.$currency.multiplier))
        if (this.stockBatchNo) { data.batch_no = this.stockBatchNo }
        if (this.expiryDateField) { data.expiry_date = this.selectedExpiryDate }
      }
      if (this.remarks) { data.remarks = this.remarks }
      const endpoint = `/products/${this.product.id}/inventories`
      this.$axios.post(endpoint, data)
        .then(resp => {
          // if (resp.data.action === 'received') {
          //   let id = resp.data.id
          //   if (this.invoice.id) {
          //     const payload = {
          //       product_inventory_id: id
          //     }
          //     this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/${this.invoice.id}/items/`, payload)
          //       .catch(() => {
          //         this.showMessage(['error', 'Error adding item to the selected invoice'])
          //       })
          //   } else if (this.addInvoice) {
          //     const payload = {
          //       invoice_no: this.stockInvoiceNo,
          //       record_date: this.selectedInvoiceDate,
          //       seller: this.seller.sold_by,
          //       product_inventory_ids: [id]
          //     }
          //     this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/`, payload)
          //       .catch(() => {
          //         this.showMessage(['error', 'Error creating invoice'])
          //       })
          //   }
          // }
          let balance = resp.data.balance
          this.$emit('update', balance)
          this.updateActivityLog(endpoint, data, resp, 'POST',`Update stock: ${resp.data.action}`, resp.data.id)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getCurrentStock () {
      let text = 'Current stock: '
      if (this.stockChange) {
        if (this.stockAction === 're-count') {
          if (this.stockChange > this.stockCount) {
            text = `<span class="font-semibold"> ${this.stockChange} `
            text += `<span class="font-normal"> (+${Number(this.stockChange) - Number(this.stockCount)} from before)`
          } else if (this.stockChange < this.stockCount) {
            text = `<span class="font-semibold"> ${this.stockChange} `
            text += `<span class="font-normal"> (${Number(this.stockChange) - Number(this.stockCount)} from before)`
          } else {
            text = `<span class="font-semibold"> ${this.stockChange}`
          }
        } else if (this.stockAction === 'received') {
          text = `<span class="font-normal"> ${this.stockCount}+${this.stockChange}=`
          text += `<span class="font-semibold">${Number(this.stockCount) + Number(this.stockChange)}`
        } else {
          text = `<span class="font-normal"> ${this.stockCount}-${this.stockChange}=`
          text += `<span class="font-semibold">${Number(this.stockCount) - Number(this.stockChange)}`
        }
        return text
      }
      return text + this.stockCount
    },
    getPrefix (action) {
      if (action === 're-count') {
        return null
      } else if (action === 'received') {
        return '+'
      } else {
        return '-'
      }
    },
    pickDate (field, picker, date) {
      this[field] = this.$options.filters.humanizeDate(date)
      this[picker] = false
    },
    checkAction () {
      if (this.stockAction === 'received' ) {
        this.updateCost()
      }
    },
    updateCost () {
      let stock = this.stockChange || 0
      let cost = this.stockCost || 0
      let costPerItem = Number(cost) / (Number(stock) || 1)
      this.costPerItem = costPerItem.toFixed(2)
    },
    changeInvoiceSelection (data) {
      this.addInvoice = data
      this.invoice = {}
      this.seller = {}
    },
    closeDialog () {
      this.$emit('closed')
    },
    updateActivityLog (endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'inventory',
        activity: activity,
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
</style>